// extracted by mini-css-extract-plugin
export default {"rec-navbar-container":"navbar_rec-navbar-container__Hwb3R","logo":"navbar_logo__Dsy7u","li-nav-sd-button":"navbar_li-nav-sd-button__EMzLZ","li-nav":"navbar_li-nav__rpQun"};